export default {
    show: function(msg) {
        if(window.plugins)
        {
            window.plugins.toast.hide();
            window.plugins.toast.show(msg, 'short', 'bottom', function(a){console.log('toast success: ' + a)}, function(b){alert('toast error: ' + b)});
        }
    }
}  